import { render, staticRenderFns } from "./GetLeavingCertVEIS.vue?vue&type=template&id=709dcaeb&"
import script from "./GetLeavingCertVEIS.vue?vue&type=script&lang=js&"
export * from "./GetLeavingCertVEIS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports